import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './core/App';
import { registerSwUpdate } from './core/lib/swUpdate';
import './styles.css';

// Manual SW registration so we can surface `onNeedRefresh` in the UI.
// Replaces vite-plugin-pwa's auto-injected registerSW script.
const updateSW = registerSW({
  onNeedRefresh() {
    registerSwUpdate(updateSW);
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
